import config from '../../../config/config';
import {
  UpdateEmail,
  UpdatePhoneNumber,
  UpdateStripeId,
} from '../../../interface/partner-interfaces/profile.interface';
import getRequest from '../base/get';
import patchRequest from '../base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Function to fetch list of Accounts
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the list of accounts
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || 5 };
    return getRequest(`${config.subscription.accountApiUrl}`, { ...parameters });
  },
  /**
   * Function to update email / phone number
   * @param {any} data - The update data (email or phone number)
   * @returns {any} A promise that resolves with the update status
   */
  updateEmailPhoneNumber: (data: UpdateEmail | UpdatePhoneNumber): Promise<any> => {
    return patchRequest(
      `${config.subscription.accountApiUrl}api/partner/v1/users/update-phone-number-email`,
      data,
    );
  },

  /**
   * Function to update the Stripe ID for a user.
   * Sends a PATCH request to the API with the provided data.
   * @param {any} data - The data containing the Stripe ID to update.
   * @returns {any} - A promise that resolves with the API response.
   */
  updateStripeID: (data: UpdateStripeId): Promise<any> => {
    return patchRequest(`${config.subscription.accountApiUrl}api/facility/v1/account/update-stripe-id`, data);
  },

  /**
   * Function to get the Stripe ID for a user.
   * Sends a GET request to the API.
   * @param {any} data - The request data
   * @returns {any} A promise that resolves with the API response
   */
  getAccount: (data: any): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/facility/v1/account/get-account`, { ...data });
  },
};
